import { xExtendClassForDOM, XTemplateDOM } from './XDOM.js';
import { xObject, xString } from './XTypes.js';

import template from './XPageSettingsSEO.html?raw';

export class XPageSettingsSEOReactive
{
    static get type          () { return 'XPageSettingsSEO';  }
    static get specification () 
    {
        return xObject({
            $: XPageSettingsSEOReactive.type,
            author: xString(''),
            twitterCreator: xString(''),
            description: xString('', {
                localized: true
            })
        });
    }

    static #template;

    static initDOM(domEnvironment)
    {
        this.#template = new XTemplateDOM(template, XPageSettingsSEOReactive.specification, domEnvironment);
    }

    #data;
    #dom;
    #page;

    constructor(data, page)
    {
        this.#data = data;
        this.#dom  = XPageSettingsSEOReactive.#template._createAccessibleDOM(data);
        this.#page = page;
    };

    get _dom () { return this.#dom;  }
    get page () { return this.#page; }
    get data () { return this.#data; }
};
xExtendClassForDOM(XPageSettingsSEOReactive);
